import { round } from '../helpers/numberHelpers';

export const createMap = async (elementId, options = {}) => {

    const mapElement = document.getElementById(elementId);

    if (!mapElement) {
        throw new Error(`Map element with id "${elementId}" not found`);
    }

    const [mapsLib, markerLib] = await Promise.all([
        google.maps.importLibrary('maps'),
        google.maps.importLibrary('marker')
    ]);

    const defaultOptions = {
        mapId: '5322c7dfa0ee2976',
        streetViewControl: false,
        draggable: true,
        scrollwheel: false,
        mapTypeControl: false,
        panControl: true,
        zoomControl: true,
        center: { lat: 28.3644, lng: -82.6934 },
        zoom: 8
    };

    return new google.maps.Map(
        mapElement,
        { ...defaultOptions, ...options }
    );
};

export const createMarker = async ({
    map,
    position,
    icon = '/images/site/maps/white-pin.svg',
    title = '',
    className = 'custom-marker',
    size = { width: 58, height: 58 },
    anchor = { x: 35, y: 70 },
    id = ''
}) => {



    const pinElement = document.createElement('div');
    pinElement.setAttribute('id', id);
    pinElement.setAttribute('title', title);
    pinElement.setAttribute('lat', position.lat);
    pinElement.setAttribute('lng', position.lng);
    pinElement.className = className;
    pinElement.innerHTML = `<img src="${icon}" alt="${title}" style="width: ${size.width}px; height: ${size.height}px;">`;

    const marker = new google.maps.marker.AdvancedMarkerElement({
        map,
        position: new google.maps.LatLng( typeof position.lat === 'string' ? parseFloat(position.lat) : position.lat, typeof position.lng === 'string' ? parseFloat(position.lng) : position.lng),
        content: pinElement,
        title
    });

    marker.id = id;
    marker.title = title;
    marker.content.style.transform = 'translateY(50%)';

    return marker;

};

export const createInfoWindow = (options = {}) => {
    const defaultOptions = {
        maxWidth: 400,
        pixelOffset: new google.maps.Size(0, 0)
    };

    const infoWindow = new google.maps.InfoWindow({
        ...defaultOptions,
        ...options
    });

    google.maps.event.addListener(infoWindow, 'domready', () => {
        const parent = document.querySelector('.gm-style-iw').parentNode;
        parent.classList.add('custom-iw');
        parent.lastChild.classList.add('custom-close-iw');
        parent.firstChild.classList.add('custom-window-iw');
    });

    return infoWindow;
};

export const fitMapBounds = (map, markers, maxZoom = 10) => {
    if (!markers || !markers.length) return;

    const bounds = new google.maps.LatLngBounds();
    markers.forEach(marker => bounds.extend(marker.position));

    map.fitBounds(bounds);

    if (map.getZoom() > maxZoom) {
        map.setZoom(maxZoom);
    }
};

export const communityContentPopup = (community) => {
    // Crear el contenedor principal
    const container = document.createElement('div');
    container.className = 'iw-hover-title';

    // Crear el enlace
    const link = document.createElement('a');
    link.href = community.url;
    link.textContent = community.name;

    // Añadir el enlace al contenedor
    container.appendChild(link);

    return container;
};


// WEBPACK FOOTER //
// ./resources/components/utils/mapUtils.js